"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePromotionsNotification;
var _api = require("@whitbread-eos/api");
var _react = require("react");
var _helpers = require("../helpers");
var _useFeatureToggle = _interopRequireDefault(require("./use-feature-toggle"));
function usePromotionsNotification() {
  var isWindowDefined = typeof window !== 'undefined';
  var [showPromotionsNotification, setShowPromotionsNotification] = (0, _react.useState)(false);
  var {
    [_api.FT_PI_PROMO_CODE_LANDING_PAGE]: isPromoCodeLandingPageEnabled
  } = (0, _useFeatureToggle.default)();
  (0, _react.useEffect)(() => {
    if (isWindowDefined) {
      var isPromoCodeSessionStoragePresent = Boolean(sessionStorage.getItem(_api.PROMO_CODE_LANDING_PAGE_SESSION));
      var isLandingPagePromoCodePresent = Boolean((0, _helpers.getCookie)(_api.PROMO_CODE_LANDING_PAGE_COOKIE));
      if (isPromoCodeLandingPageEnabled && isPromoCodeSessionStoragePresent && isLandingPagePromoCodePresent) {
        setShowPromotionsNotification(true);
      }
    }
    return () => {
      setShowPromotionsNotification(false);
    };
  }, [isWindowDefined, isPromoCodeLandingPageEnabled]);
  return {
    showPromotionsNotification
  };
}